// Map tenant theme color keys → CSS variable names
const COLOR_MAP: Record<string, string> = {
    bgColor: '--bg-color',
    surfaceColor: '--surface-color',
    surfaceHover: '--surface-hover',
    primary: '--primary',
    primaryChannels: '--primary-channels',
    primaryGlow: '--primary-glow',
    secondary: '--secondary',
    secondaryChannels: '--secondary-channels',
    secondaryGlow: '--secondary-glow',
    accent: '--accent',
    textMain: '--text-main',
    textMuted: '--text-muted',
    textDim: '--text-dim',
    border: '--border',
    borderActive: '--border-active',
    glassBg: '--glass-bg',
    glassBorder: '--glass-border',
}

function applyThemeColors(colors: Record<string, string>) {
    if (typeof document === 'undefined') return
    const root = document.documentElement
    for (const [key, cssVar] of Object.entries(COLOR_MAP)) {
        if (colors[key]) {
            root.style.setProperty(cssVar, colors[key])
        }
    }
}

function applyThemeFonts(fonts: { heading?: string; body?: string; headingUrl?: string; bodyUrl?: string }) {
    if (typeof document === 'undefined') return
    const root = document.documentElement
    if (fonts.heading) root.style.setProperty('--font-heading', `'${fonts.heading}', sans-serif`)
    if (fonts.body) root.style.setProperty('--font-sans', `'${fonts.body}', system-ui, sans-serif`)

    // Load custom font URLs if provided
    if (fonts.headingUrl) loadFont(fonts.heading!, fonts.headingUrl)
    if (fonts.bodyUrl) loadFont(fonts.body!, fonts.bodyUrl)
}

function loadFont(family: string, url: string) {
    if (typeof document === 'undefined') return
    if (document.querySelector(`link[data-font="${family}"]`)) return
    const link = document.createElement('link')
    link.rel = 'stylesheet'
    link.href = url
    link.dataset.font = family
    document.head.appendChild(link)
}

export default defineNuxtPlugin(async () => {
    const tenant = useState('tenant')

    try {
        const fetchFn = useRequestFetch()
        const data = await fetchFn('/api/tenant/current')
        tenant.value = data

        // Apply tenant theme colors + fonts to CSS variables
        const theme = (data as any)?.theme
        if (theme?.colors && Object.keys(theme.colors).length) {
            applyThemeColors(theme.colors)
        }
        if (theme?.fonts) {
            applyThemeFonts(theme.fonts)
        }
    } catch {
        // Silently fail — default tenant values from composable will be used
    }
})
